import {ReactNode} from 'react';
import dayjs from 'dayjs';
import {Tooltip} from 'antd';
import {ArrowLongRightIcon} from '@heroicons/react/24/outline';
import {dateFormat, dateTimeFormat} from '../../../forms/DatePickerField';
interface DateCellProps {
  value: string;
}

export const DateCell = ({ value }: DateCellProps) => {
  const date = dayjs(value)
  return (
    <Tooltip placement="bottom" title={date.format(dateTimeFormat)}>
      <time dateTime={value}>{date.format(dateFormat)}</time>
    </Tooltip>
  );
};


interface DateRangeCellProps {
  start: string;
  end: string;
}
const Range = ({ left, right }: {left: ReactNode; right: ReactNode}) => (
  <div className="flex items-center">
    {left}
    <ArrowLongRightIcon className="m-1 h-3 w-3" />
    {right}
  </div>
)

export const DateRangeCell = ({start, end}: DateRangeCellProps) => {
  const startDate = dayjs(start)
  const endDate = dayjs(end)
  return (
    <Tooltip placement="bottom"
      title={
        <Range
          left={startDate.format(dateTimeFormat)}
          right={endDate.format(dateTimeFormat)}
        />
      }>
      <div>
        <Range
          left={<time dateTime={start}>{startDate.format(dateFormat)}</time>}
          right={<time dateTime={end}>{endDate.format(dateFormat)}</time>}
        />
      </div>
    </Tooltip>
  );
}
